import { render, staticRenderFns } from "./checkbox-widget.vue?vue&type=template&id=70a5f1c3&scoped=true"
import script from "./checkbox-widget.vue?vue&type=script&lang=js"
export * from "./checkbox-widget.vue?vue&type=script&lang=js"
import style0 from "./checkbox-widget.vue?vue&type=style&index=0&id=70a5f1c3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a5f1c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70a5f1c3')) {
      api.createRecord('70a5f1c3', component.options)
    } else {
      api.reload('70a5f1c3', component.options)
    }
    module.hot.accept("./checkbox-widget.vue?vue&type=template&id=70a5f1c3&scoped=true", function () {
      api.rerender('70a5f1c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/form-widget/field-widget/checkbox-widget.vue"
export default component.exports